import React, { useEffect, useState } from "react";
import "./StepFormConfrimationPopup.scss";
import Modal from "react-bootstrap/Modal";
import { useWindowSize } from "react-use";
import { checkMarkOrange, modalCloseIcon } from "../../../../../images";
import useTheme from "../../../../../components/useTheme/useTheme";

const StepFormConfrimationPopup = (props) => {
  const { theme } = useTheme();
  const [confrimation, setConfirmation] = useState(false);

  const checkConfirmation = (e) => {
    setConfirmation(e.target.checked);
  };

  return (
    <>
      <Modal
        {...props}
        centered
        className={`general_info_popup confm_modal_stp_frm cfm_ins_arr ${
          theme === "dark" && "confm_modal_stp_frm--dark-mode"
        }`}
        backdropClassName={`${
          theme === "light"
            ? "custom-backdrop"
            : "custom-backdrop--dark-mode-confm"
        }`}
      >
        <Modal.Header>
          <button
            className="custom-cancel-btn"
            onClick={() => {
              props.handleClose();
              setConfirmation(false);
            }}
          >
            <img
              src={modalCloseIcon}
              alt="close-icon"
              className="ctm_img_bussine_edit_about"
            />
          </button>
        </Modal.Header>
        <Modal.Body>
          <h2
            className={`about_modal_bussines_heading fw-semibold text-center ${
              theme === "dark" && "text-white"
            }`}
          >
            Are you sure?
          </h2>

          <p
            className={`pera_cnfm_step_fm  ${theme === "dark" && "text-secondary"}`}
            dangerouslySetInnerHTML={{ __html: props.data }}
          ></p>
          <p
            className={`pera_cnfm_step_fm  ${theme === "dark" && "text-secondary force-text-white"}`}
            dangerouslySetInnerHTML={{ __html: props.dataNextStep }}
          ></p>

          <div className="checbox_wrapper_ctm">
            <label className="custom-checkbox ctm_form_check_lb">
              <input
                type="checkbox"
                className="custom-checkbox__input"
                checked={confrimation}
                onChange={checkConfirmation}
              />
              <span className="custom-checkbox__box">
                <img
                  src={checkMarkOrange}
                  alt="Checked"
                  className="custom-checkbox__icon"
                />
              </span>
              <span
                className={` ${theme === "dark" && "text-white"}`}
                dangerouslySetInnerHTML={{ __html: props.label }}
              ></span>
            </label>
          </div>

          <div className="info_select_container cfm_cont_cta">
            <div className={`field_wrapper`}>
              <button
                type="submit"
                className={`popup_common_btn cfm_cta_next ${
                  !confrimation ? "disabledState" : ""
                }`}
                onClick={() => {
                  if (confrimation) {
                    props.nextStep();
                  }
                }}
              >
                Yes, I am sure
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default StepFormConfrimationPopup;
